import {Injectable} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private snackBar: MatSnackBar) {
    }

    async success(message: string, interpolateParams?: Object, duration: number = 5000) {
        this.showMessage('notification-success', message, duration);
    }

    async failure(message: string, interpolateParams?: Object, duration: number = 5000) {
        this.showMessage('notification-failure', message, duration);
    }

    private showMessage(panelClass: string, message: string, duration?: number) {
        this.snackBar.open(message, 'X', {
            panelClass: panelClass,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
          duration: duration
        });
    }
}
